<template>
    <v-list style="margin-left: 0%; margin-right: 0%;">
        <v-list-group
            v-for="cat in categories"
            :key="cat.title"
            v-model="cat.active"
            :prepend-icon="cat.icon"
            no-action
        >
          <template v-slot:activator>
            <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                    <v-list-item-content v-bind="attrs" v-on="on">
                      <v-list-item-title>
                        {{ cat.title }}
                        <strong v-if="cat.invoices.length" :style="{ color: cat.color }">
                          {{ cat.invoices.length }}
                        </strong>
                      </v-list-item-title>
                    </v-list-item-content>
                </template>
                <span>{{ cat.description }}</span>
            </v-tooltip>
          </template>

            <v-list-item style="margin-left: 0%; margin-right: 0%;">
              <div class="table-container">
                <v-data-table
                    dense
                    :headers="headers"
                    :items="cat.invoices"
                    :items-per-page="cat.invoices.length <= itemsPerPage ? cat.invoices.length : itemsPerPage"
                    :hide-default-footer="cat.invoices.length <= itemsPerPage"
                    item-key="icon"
                    class="elevation-1"
                    style="width: 100%"
                ></v-data-table>
              </div>
            </v-list-item>
        </v-list-group>
    </v-list>
</template>

<script>
import moment from 'moment'
import RugTablesBlu from '@/common/RugTablesBlu'
import RugGuaranteesStatus from '@/common/RugGuaranteesStatus'
import RiskInsightsService from '@/services/RiskInsightsService'

export default {
  name: 'Payments',
  props: {
    invoices: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      rugTablesBlu: RugTablesBlu,
      rugGuaranteesStatus: RugGuaranteesStatus,
      activeInvoices: [],
      invoicesBalance: [],
      headers: [
        {
          text: 'FACTURA',
          align: 'start',
          value: 'folio'
        },
        {
          text: 'TOTAL',
          value: 'formattedTotal',
          align: 'end'
        },
        {
          text: 'PROMESA PAGO',
          value: 'formattedDueDate',
          align: 'end'
        }
      ],
      itemsPerPage: 10
    }
  },
  created () {
    this.setInvoicesBalance()
  },
  watch: {
    invoices (newVal, oldVal) {
      // Clona el array de facturas en credito una vez que este disponible
      if (newVal.length >= this.activeInvoices.length) { // Evitar que cambie el array de facturas cuando seleccionan un producto en la card de mis facturas vendidas
        this.activeInvoices = newVal.map(invoice => ({
          ...invoice,
          formattedDueDate: this.formatFecha(invoice.dueDate),
          formattedTotal: this.formatMonto(invoice.total, invoice.currency)
        }))
      }
    }
  },
  methods: {
    async setInvoicesBalance () {
      const clientId = this.$store.getters.user.clientId
      const balances = await RiskInsightsService.getInvoicesBalance(clientId)
      this.invoicesBalance = balances.items
    },
    formatFecha (fecha) {
      return moment(fecha).format('DD/MM/YYYY')
    },
    formatMonto (monto, currency) {
      const formattedTotal = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
      }).format(monto)
      return `${formattedTotal} ${currency}`
    }
  },
  computed: {
    categories () {
      return [
        {
          icon: 'mdi-alert',
          invoices: this.overdueInvoices,
          title: 'Facturas vencidas con Blú',
          description: 'Estas facturas han superado la fecha de pago',
          color: 'red'
        },
        {
          icon: 'mdi-cancel',
          invoices: this.canceledInvoices,
          title: 'Facturas canceladas en SAT',
          description: 'Liquida de inmediato consulta con tu asesor la sustitución correspondiente',
          color: 'red'
        },
        {
          icon: 'mdi-cash-sync',
          invoices: this.paidInvoices,
          title: 'Liquidadas por tu cliente',
          description: 'Tu cliente ya realizó el pago, debes liquidar en un plazo máximo de 48 horas',
          color: 'red'
        },
        {
          icon: 'mdi-account-cancel',
          invoices: this.rugInvoices,
          title: 'Cedidas a otra financiera',
          description: 'Evita la suspensión de tu línea liquidando de inmediato',
          color: 'red'
        },
        {
          icon: 'mdi-clock-alert',
          invoices: this.soonToExpire,
          title: 'Próximas a vencer con Blú',
          description: 'Estas facturas vencerán en los próximos 7 días',
          color: 'orange'
        }
      ]
    },
    overdueInvoices () {
      return this.activeInvoices.filter(invoice => new Date(invoice.dueDate) <= new Date())
    },
    canceledInvoices () {
      return this.activeInvoices.filter(invoice => invoice.satCancelled)
    },
    paidInvoices () {
      return this.activeInvoices.filter(invoice => this.invoicesBalance.find(balance => balance.uuid === invoice.uuid.toUpperCase() && balance.fully_paid_at))
    },
    rugInvoices () {
      return this.activeInvoices.filter(invoice =>
        invoice.credit?.rugGuaranteeBlu.some(guarantee =>
          guarantee.status === this.rugTablesBlu.credit &&
          guarantee.rugStatus === this.rugGuaranteesStatus.EXTERNAL
        )
      )
    },
    creditedInvoices () {
      return this.activeInvoices.filter(invoice => this.invoicesBalance.find(balance => balance.uuid === invoice.uuid.toUpperCase() && balance.credited_amount))
    },
    soonToExpire () {
      const today = new Date()
      today.setDate(today.getDate() + 1)

      const nextWeek = new Date()
      nextWeek.setDate(nextWeek.getDate() + 7)

      return this.activeInvoices.filter(invoice => {
        const dueDate = new Date(invoice.dueDate)
        return dueDate >= today && dueDate <= nextWeek
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table-container {
  width: 100%;
  max-width: none;
  overflow-x: auto;
}

</style>
